export function getFileName(fileName) {
  if (fileName.length > 30) {
    return `${fileName.slice(0, 20)}...${fileName.slice(-6)}`
  }

  return fileName
}

export function getFilePreviewImageSrc(file) {
  return file.origin
}
